/**
 * Catálogo de códigos de país soportados en el registro/selector de
 * teléfono. Cada entrada tiene:
 *  - code: ISO 3166-1 alpha-2 (ej "MX") — útil como key y futura i18n
 *  - dial: prefijo telefónico internacional con "+" (ej "+52")
 *  - name: nombre en español usado en el dropdown
 *  - flag: emoji de bandera (rinde igual en todos los navegadores modernos)
 *  - length: longitud esperada del número LOCAL (sin el prefijo).
 *            Usamos tuplas [min, max] porque varía por país.
 *
 * Por defecto usamos México — es el mercado principal de Gas2GO. El resto
 * de países LatAm + Spain + US/Canada cubren los casos frecuentes de
 * migrantes que piden a familia o empresas con operación regional.
 */
export const COUNTRY_CODES = [
  { code: "MX", dial: "+52", name: "México",            flag: "🇲🇽", length: [10, 10] },
  { code: "US", dial: "+1",  name: "Estados Unidos",    flag: "🇺🇸", length: [10, 10] },
  { code: "CA", dial: "+1",  name: "Canadá",            flag: "🇨🇦", length: [10, 10] },
  { code: "AR", dial: "+54", name: "Argentina",         flag: "🇦🇷", length: [10, 11] },
  { code: "BO", dial: "+591",name: "Bolivia",           flag: "🇧🇴", length: [8, 8] },
  { code: "BR", dial: "+55", name: "Brasil",            flag: "🇧🇷", length: [10, 11] },
  { code: "CL", dial: "+56", name: "Chile",             flag: "🇨🇱", length: [9, 9] },
  { code: "CO", dial: "+57", name: "Colombia",          flag: "🇨🇴", length: [10, 10] },
  { code: "CR", dial: "+506",name: "Costa Rica",        flag: "🇨🇷", length: [8, 8] },
  { code: "CU", dial: "+53", name: "Cuba",              flag: "🇨🇺", length: [8, 8] },
  { code: "DO", dial: "+1",  name: "República Dominicana",flag: "🇩🇴", length: [10, 10] },
  { code: "EC", dial: "+593",name: "Ecuador",           flag: "🇪🇨", length: [9, 9] },
  { code: "SV", dial: "+503",name: "El Salvador",       flag: "🇸🇻", length: [8, 8] },
  { code: "ES", dial: "+34", name: "España",            flag: "🇪🇸", length: [9, 9] },
  { code: "GT", dial: "+502",name: "Guatemala",         flag: "🇬🇹", length: [8, 8] },
  { code: "HN", dial: "+504",name: "Honduras",          flag: "🇭🇳", length: [8, 8] },
  { code: "NI", dial: "+505",name: "Nicaragua",         flag: "🇳🇮", length: [8, 8] },
  { code: "PA", dial: "+507",name: "Panamá",            flag: "🇵🇦", length: [8, 8] },
  { code: "PY", dial: "+595",name: "Paraguay",          flag: "🇵🇾", length: [9, 9] },
  { code: "PE", dial: "+51", name: "Perú",              flag: "🇵🇪", length: [9, 9] },
  { code: "PR", dial: "+1",  name: "Puerto Rico",       flag: "🇵🇷", length: [10, 10] },
  { code: "UY", dial: "+598",name: "Uruguay",           flag: "🇺🇾", length: [8, 9] },
  { code: "VE", dial: "+58", name: "Venezuela",         flag: "🇻🇪", length: [10, 10] },
];

export const DEFAULT_COUNTRY = COUNTRY_CODES[0]; // México

/** Devuelve el país a partir de su código ISO (o el default). */
export function findCountry(isoCode) {
  return COUNTRY_CODES.find((c) => c.code === isoCode) || DEFAULT_COUNTRY;
}

/** Arma el teléfono E.164 (`+<dial><localDigits>`) listo para persistir. */
export function formatE164(country, localDigits) {
  const digits = (localDigits || "").replace(/\D/g, "");
  return `${country.dial}${digits}`;
}

/** Valida que `localDigits` caiga dentro del rango esperado del país. */
export function isValidPhone(country, localDigits) {
  const digits = (localDigits || "").replace(/\D/g, "");
  const [minL, maxL] = country.length;
  return digits.length >= minL && digits.length <= maxL;
}
